<template>
    <main-layout :showHeader="false" :showSidebar="false">
        <template slot="content">
            <div class="download-body">
                <div class="slider">
                    <div class="line"></div>
                    <div class="subline inc"></div>
                    <div class="subline dec"></div>
                </div>
                <h2 class="text-gray">{{ $t('LBL_DOWNLOAD_IN_PROGRESS') }}</h2>
            </div>
        </template>
    </main-layout>
</template>

<script>

    import MainLayout from '@/layout/Main'

    export default {
        components: {
            'main-layout': MainLayout,
        },

        async mounted() {
            var self = this
            var fileId = this.$route.params.file
            var response = await Api.download(fileId)

            setTimeout(function(){
                var blob = new Blob([response], { type: 'application/zip' } )
                var link = document.createElement('a')
                var url = window.URL.createObjectURL(blob)

                link.href = url
                link.download = 'export_' + fileId + '.zip'
                document.body.appendChild(link);
                link.click()

                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)

                self.$router.push({path: '/home/'})
            }, 2000)
        }
    }
</script><style lang="scss">@import "@/assets/scss/pages/_download.scss";</style>